import {Modal} from "antd";
import {delay} from "@lib/utils";
import React from "react";

export const showInfoModal = async (options) => {
    Modal.info(options);
    await delay(100); //Wait for the element to start render.
    const elements = document.getElementsByClassName('ant-modal');
    if (elements && elements.length > 0) {
        const elem = elements[0];
        await delay(100); //Wait for element to be populated.
        elem.scrollIntoView();
    }
};